module.exports = __webpack_public_path__ + "9653f6f097baf3ca7ce84feb4bdaa205.svg";